<template>
    <div id="MainLayout">
        <Header :dark="dark"></Header>
        <!-- * 收藏  -->
        <div class="container relative" v-if="favorite">
            <div class="absolute top-[40px] right-0 z-[6]">
                <Favorites />
            </div>
        </div>
        <div id="MainLayoutContainer">
            <slot></slot>
        </div>

        <Footer v-if="footer" :top="top"></Footer>
    </div>
</template>

<script lang="ts" setup>
//* 公共组件
import { Header, Footer } from "@/components/complete";
import { Favorites } from "@/components/controls";
//* 组件属性注册
defineProps({
    top: { type: Number },
    dark: { type: Boolean, default: false },
    footer: { type: Boolean, default: true },
    favorite: { type: Boolean, default: false },
});
</script>

<style lang="less" scoped>
#MainLayout {
    margin: 0 auto;
    display: flex;
    min-width: 1400px;
    max-width: 2560px;
    min-height: 100vh;
    flex-direction: column;
    #MainLayoutContainer {
        flex: 1;
        position: relative;
    }
}

#MainLayout {
    :deep(.container) {
        width: 1328px;
    }
}
</style>
